import React from "react";
import { STATUS_LABELS, statusBadgeClass, flagDot, flagLabel } from "@/lib/api";

export function StatusBadge({ status, testid }) {
  return (
    <span data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${statusBadgeClass(status)}`}>
      {STATUS_LABELS[status] || status || "-"}
    </span>
  );
}

export function FlagBadge({ flag }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-600">
      <span className={`h-2.5 w-2.5 rounded-full ${flagDot(flag)}`} />
      {flagLabel(flag)}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-display font-extrabold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}
